import type { ProfileChange } from './profile-history'
import apiClient from '@/services/api/client'
import type { Paginated } from '@/services/api/types'
import type { StaffUser, StaffVendorMembership } from '@/types/staff-user'

const PATH = '/api/v1/staff-users'

export interface StaffUserCreatePayload {
  email: string
  password: string
  firstName: string
  lastName: string
  roleId: number
  suspended?: boolean
  twoFactorEnabled?: boolean
  twoFactorMethod?: 'email' | string | null
  metadata?: Record<string, unknown> | null
  tourState?: StaffUser['tourState']
  vendorMemberships?: Partial<StaffVendorMembership>[]
  scannerAccessMode?: 'all' | 'selected'
  scannerEventIds?: number[]
}

export type StaffUserPatchPayload = Partial<
  Omit<StaffUserCreatePayload, 'password'> & { password?: string; profileChangeConfirmation?: ProfileChange[] }
>

export const staffUsersApi = {
  async find(params?: Record<string, unknown> & { $skip?: number; $limit?: number; $sort?: Record<string, 1 | -1> }) {
    const res = await apiClient.get<Paginated<StaffUser>>(PATH, { params })
    return res.data
  },

  async get(id: number) {
    const res = await apiClient.get<StaffUser>(`${PATH}/${id}`)
    return res.data
  },

  async create(body: StaffUserCreatePayload) {
    const res = await apiClient.post<StaffUser>(PATH, body)
    return res.data
  },

  async patch(id: number, body: StaffUserPatchPayload) {
    const res = await apiClient.patch<StaffUser>(`${PATH}/${id}`, body)
    return res.data
  },

  async remove(id: number) {
    await apiClient.delete(`${PATH}/${id}`)
  },
}
